//
import WebComponent from '../src/webComponents/WebComponent';
import tippy from 'tippy.js';
import $ from 'jquery';

class NumberInput extends WebComponent {
  constructor(props) {
    super(props);
    this.showTooltip = this.showTooltip.bind(this);
    this.hideTooltip = this.hideTooltip.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleIncrease = this.handleIncrease.bind(this);
    this.handleDecrease = this.handleDecrease.bind(this);
    this.handleInputKeypress = this.handleInputKeypress.bind(this);
    this.handleInputKeyup = this.handleInputKeyup.bind(this);
  }

  didMount() {
    const {
      min,
      max,
      defaultValue,
      step,
      showTooltip,
      actionButton,
    } = this.props;

    // vypnutí našeptávače
    this.element.setAttribute('autocomplete', 'off');

    // force input[type=text], number nechceme kvůli možnosti zapisování desetinné čárky
    this.element.setAttribute('type', 'text');

    this.changeTimeout = null;

    // obalit spanem, kvůli případnému stylování šipek
    this.wrapper = this.createWrapper();
    this.parentEl = this.element.closest('.dhtml-number');

    // nastavení proměnných z data atributů
    this.minValue = parseFloat(min) || 0;
    this.maxValue = parseFloat(max) || null;
    this.defaultValue = parseFloat(String(this.element.value || defaultValue).replace(',', '.'));
    this.stepRaw = step;		// použito pro formátování desetinných míst přesně dle stepu (zachování stringu)
    this.step = parseFloat(this.stepRaw);
    this.decimals = this.getNumberOfDecimals();

    this.maxReached = false;
    this.minReached = false;
    this.valueFixed = false;

    this.message = null;

    this.directionIncrease = true;
    this.lastValue = this.defaultValue;
    this.currentDiff = 0;

    // set initial value
    this.element.value = this.applyLocalizedFormatting(this.defaultValue);
    this.actualValue = this.defaultValue;

    // related action button
    if (actionButton) {
      this.actionButton = document.querySelector(actionButton);
    }
    else {
      this.actionButton = null;
    }

    // render controls and handles them
    this.renderControls();
    this.bindEvents();

    if (showTooltip) {
      this.tip = tippy(this.parentEl, {
        arrow: true,
        theme: 'esp',
        placement: 'top',
        trigger: 'manual',
        hideOnClick: false,
      });
      this.renderTooltip();
    }
  }

  willUnMount() {
    const {
      showTooltip,
    } = this.props;

    if (showTooltip && this.tip) {
      this.tip.destroy();
    }
    this.increase.removeEventListener('click', this.handleIncrease);
    this.decrease.removeEventListener('click', this.handleDecrease);
    this.element.removeEventListener('keypress', this.handleInputKeypress);
    this.element.removeEventListener('keyup', this.handleInputKeyup);
    this.element.removeEventListener('focus', this.handleFocus);
    this.element.removeEventListener('blur', this.handleBlur);
    this.parentEl.removeEventListener('mouseenter', this.showTooltip);
    this.parentEl.removeEventListener('mouseleave', this.hideTooltip);
  }


  /**
   * vytvoří wrapper kolem inputu, aby bylo možné jednoduše nastylovat spinner
   * @returns {*}
   * @private
   */
  createWrapper() {
    const {
      wrapperClass,
    } = this.props;

    let wrapper = null;

    wrapper = document.createElement('span');
    this.element.parentNode.insertBefore(wrapper, this.element);
    wrapper.appendChild(this.element);
    wrapper.classList.add(wrapperClass);

    return wrapper;
  };


  /**
   * extrahuje počet desetinných míst dle stepu
   *
   */
  getNumberOfDecimals() {
    const s = String(this.stepRaw);
    let len = 0;
    if (s.indexOf('.') > -1) {
      len = s.substring(s.indexOf('.') + 1, s.length).length;
    }

    return len;
  };

  applyLocalizedFormatting(num) {
    return String(this.roundByDecimals(num)).replace(',', '.');
  };


  /**
   * zaokrouhlení čísla na tolik desetinných míst, na kolik byl definován původní step
   * @private
   */
  roundByDecimals(num) {
    return Number(num).toFixed(this.decimals);
  };

  renderTooltip() {
    this.defaultTooltip = null;

    if ((this.minValue && this.maxValue && this.minValue == 1) || (this.minValue == 0 && this.maxValue)) {
      this.defaultTooltip = this.i18n('maxTooltip');
    }
    else if (this.minValue && this.maxValue && this.minValue != 1) {
      this.defaultTooltip = this.i18n('minMaxTooltip');
    }
    else if (this.minValue && !this.maxValue && this.minValue != 1) {
      this.defaultTooltip = this.i18n('minTooltip');
    }

    if (this.defaultTooltip && this.tip) {
      this.tip.setContent(this.defaultTooltip);
    }
  }


  /**
   * renders controls for increasing and decreasing value
   * @private
   */
  renderControls() {
    const controlsWrapper = document.createElement('span');
    controlsWrapper.classList.add('form-group__buttons');
    controlsWrapper.classList.add('dhtml-number-controls-group');
    this.wrapper.appendChild(controlsWrapper);

    this.decrease = document.createElement('a');
    this.decrease.setAttribute('href', 'javascript:void(0)');
    this.decrease.setAttribute('title', '-');
    this.decrease.setAttribute('class', 'form-group__btn form-group__btn--decrease decrease');
    this.decrease.innerText = '-';

    this.increase = document.createElement('a');
    this.increase.setAttribute('href', 'javascript:void(0)');
    this.increase.setAttribute('title', '+');
    this.increase.setAttribute('class', 'form-group__btn form-group__btn--increase increase');
    this.increase.innerText = '+';

    controlsWrapper.appendChild(this.decrease);
    controlsWrapper.appendChild(this.increase);

    this.updateButtonsState();
  };

  updateButtonsState() {
    const {
      disabledStateClass,
    } = this.props;

    if ((this.minValue && this.actualValue <= this.minValue) || this.element.matches(':disabled')) {
      this.decrease.classList.add(disabledStateClass);
    } else {
      this.decrease.classList.remove(disabledStateClass);
    }

    if ((this.maxValue && this.actualValue >= this.maxValue) || this.element.matches(':disabled')) {
      this.increase.classList.add(disabledStateClass);
    } else {
      this.increase.classList.remove(disabledStateClass);
    }

    if (((this.minValue && this.actualValue <= this.minValue) || this.element.matches(':disabled')) && ((this.maxValue && this.actualValue >= this.maxValue) || this.element.matches(':disabled'))) {
      this.parentEl.classList.add(disabledStateClass);
    } else {
      this.parentEl.classList.remove(disabledStateClass);
    }
  };

  bindEvents() {
    // click plus
    this.increase.addEventListener('click', this.handleIncrease);

    // click minus
    this.decrease.addEventListener('click', this.handleDecrease);

    this.element.addEventListener('keypress', this.handleInputKeypress);

    // do validity checks and store new value
    this.element.addEventListener('keyup', this.handleInputKeyup);

    this.element.addEventListener('focus', this.handleFocus);
    this.element.addEventListener('blur', this.handleBlur);

    this.parentEl.addEventListener('mouseenter', this.showTooltip);
    this.parentEl.addEventListener('mouseleave', this.hideTooltip);
  }

  handleIncrease(e) {
    const {
      disabledStateClass,
    } = this.props;

    if (this.maxReached || this.increase.classList.contains(disabledStateClass)) {
      return false;
    }

    let val = parseFloat(this.element.value.replace(',', '.'));
    if (isNaN(val)) {
      val = this.step;
    }
    val += this.step;
    val = this.roundByDecimals(val);
    val = this.checkFitInStep(val);
    val = this.checkValidity('max', this.maxValue, val, false);

    this.storeValue(val);
  }

  handleDecrease(e) {
    const {
      disabledStateClass,
    } = this.props;

    if (this.minReached || this.decrease.classList.contains(disabledStateClass)) {
      return false;
    }

    let val = parseFloat(this.element.value.replace(',', '.'));
    if (isNaN(val)) {
      val = this.step;
    }
    val -= this.step;
    val = this.roundByDecimals(val);
    val = this.checkFitInStep(val);
    val = this.checkValidity('min', this.minValue, val, false);

    this.storeValue(val);
  }

  handleInputKeypress(e) {
    // integer
    if (Number.isInteger(this.step)) {
      this.handleKeypress(/^[0-9]+$/, e);
    }
    // float
    else {
      this.handleKeypress(/^[0-9]|[\,]|[\.]+$/, e);
    }
  }

  handleInputKeyup(e) {
    const {
      autofixTimeoutInteger,
      autofixTimeoutFloat,
      autofixTimeoutEmpty,
    } = this.props;
    const eventTarget = e.currentTarget;
    let autofixTimeout = autofixTimeoutInteger;

    if (!Number.isInteger(this.step)) {
      autofixTimeout = autofixTimeoutFloat;
    }

    // kdyz uzivatel odmaze stavajici hodnotu backspacem, nastavime vetsi timout, aby stacil napsat novou hodnotu
    if (this.element.value == '') {
      autofixTimeout = autofixTimeoutEmpty;
    }

    clearTimeout(this.changeTimeout);

    // deaktivovat actionButon behem timeout validace
    if (this.actionButton) {
      this.actionButton.setAttribute('disabled', true);
    }

    // deaktivovat PU behem timeout validace
    if (this.element.hasAttribute('data-partial-update')) {
      this.element.removeAttribute('data-partial-update');
    }


    if (e.keyCode == 13) {
      this.evaluateKeyPressed(eventTarget);
    } else {
      this.changeTimeout = window.setTimeout(() => {
        this.evaluateKeyPressed(eventTarget);
      }, autofixTimeout)
    }
  }

  handleFocus() {
    const {
      focusStateClass,
    } = this.props;
    this.parentEl.classList.add(focusStateClass);
    this.showTooltip();
  }

  handleBlur() {
    const {
      focusStateClass,
    } = this.props;

    this.parentEl.classList.remove(focusStateClass);
    this.hideTooltip();
  }

  showTooltip(tooltipText) {
    if (!this.element.matches(':disabled') && this.defaultTooltip && this.tip) {
      if (typeof(tooltipText) == 'string') {
        this.tip.setContent(tooltipText);
      }
      else {
        this.tip.setContent(this.defaultTooltip);
      }
      this.tip.show();
    }
  }

  hideTooltip(e) {
    if (this.tip) {
      this.tip.hide();
    }
  }

  handleKeypress(pattern, e) {
    const {
      allowEnter,
    } = this.props;

    const result = pattern.test(String.fromCharCode(e.which));
    const eKeyCodes = [9, 27, 46, 110, 190];

    if (((eKeyCodes.indexOf(e.keyCode) != -1) && (e.which == 0)) ||
      (e.keyCode == 8) ||
      // Allow: Ctrl+A
      (e.keyCode == 65 && e.ctrlKey === true) ||
      // Allow: Ctrl+C
      (e.keyCode == 67 && e.ctrlKey === true) ||
      // Allow: Ctrl+X
      (e.keyCode == 88 && e.ctrlKey === true) ||
      ((allowEnter) && (e.keyCode == 13))) {
      // let it happen, don't do anything
      return;
    }

    if (result) {
      return result;
    } else {
      e.preventDefault();
    }
  };

  evaluateKeyPressed(input) {
    let val = input.value;
    val = parseFloat(val.replace(',', '.'));

    if (val != '-' && isNaN(val)) {
      input.value = this.applyLocalizedFormatting(this.actualValue);
    } else {
      if (val != '-') {
        val = this.checkValidity('min', this.minValue, val, true);	// kontrola na minimum
        val = this.checkValidity('max', this.maxValue, val, true);	// kontrola na maximum
        val = this.checkFitInStep(val, true);						// kontrola na to, zda odpovídá hodnota stepu
      }

      this.storeValue(val);
    }
    // aktivovat actionButon po dokonceni timeout validace
    if (this.actionButton) {
      this.actionButton.removeAttribute('disabled');
    }
    // aktivovat PU po dokonceni timeout validace
    if (this.element.hasAttribute('data-partial-update-url')) {
      this.element.setAttribute('data-partial-update', 'change');
    }
  };

  /**
   *
   *
   */
  checkValidity(type, threshold, value, disableThresholdFlag) {
    let result, stepDiff;
    const step = this.step;

    if (type === 'max') {
      if (threshold !== null && value > threshold) {
        stepDiff = parseFloat(this.roundByDecimals(threshold % step));

        // TODO - vyřešit zápornou minValue - způsobeno nekonzistentním požadavkem, kdy minValue nemusí být nutně násobkem stepu
        if (this.minValue >= 0) {
          result = threshold - stepDiff + this.minValue;

          result = result > this.maxValue ? this.maxValue : result;
        } else {
          result = this.maxValue;
        }

      } else {
        result = value;
      }

      if (threshold && result + step > threshold && !disableThresholdFlag) {
        this.maxReached = true;
      }
    }

    if (type === 'min') {
      if (threshold !== null && value < threshold) {
        result = threshold;
      } else {
        result = value;
      }

      if (threshold && result - step < threshold && !disableThresholdFlag) {
        this.minReached = true;
      }
    }

    return result;
  };

  /**
   * kontrola, zda value je násobkem stepu, pokud ne, je vybrána nejbližší vyšší hodnota (pokud není vyšší, než maximum)
   *
   */
  checkFitInStep(value, setChangeFlag) {
    this.minReached = false;
    this.maxReached = false;

    value = parseFloat(value);

    let result = value;
    let diff = (value - this.minValue) % this.step;
    diff = diff.toFixed(this.decimals);	// oříznutí na tolik desetinných míst, kolik má step. Vyřešení problému, kdy JS počítá např. 5.2 + 2.6 = 7.800000...0001

    if (diff > 0 && diff != this.step) {
      result = value + this.step - diff;
      if(this.maxValue && result > this.maxValue) {
        result = result - this.step;
      }
      if (setChangeFlag) {
        this.valueFixed = true;
      }
    }

    if ((this.minValue) && (result == this.minValue)) {
      this.minReached = true;
    }

    if ((this.maxValue) && (result + this.step > this.maxValue)) {
      this.maxReached = true;
    }

    return result;
  }

  /**
   * trigger change
   * @private
   */
  performChange() {
    const {
      changeEvent,
      increaseEvent,
      decreaseEvent,
      changeTimeout,
    } = this.props;

    clearTimeout(this.changeTimeout);
    this.changeTimeout = setTimeout(() => {
      $(this.element).trigger(changeEvent, [{
        input: $(this.element),
        instance: this
      }]);
      if ((this.directionIncrease) && (this.currentDiff != 0)) {
        $(this.parentEl).trigger(increaseEvent, [{
          input: $(this.element),
          diff: this.currentDiff,
          instance: this
        }]);
      } else if ((!this.directionIncrease) && (this.currentDiff != 0)) {
        $(this.parentEl).trigger(decreaseEvent, [{
          input: $(this.element),
          diff: this.currentDiff,
          instance: this
        }]);
      }
    }, changeTimeout);
  };

  /**
   *
   *
   **/
  storeValue(value) {
    const {
      showTooltip,
    } = this.props;

    this.element.value = this.applyLocalizedFormatting(value);
    this.actualValue = value;

    if (this.actualValue > this.lastValue) {
      this.directionIncrease = true;
      this.currentDiff = this.actualValue - this.lastValue;
    } else if (this.actualValue < this.lastValue) {
      this.directionIncrease = false;
      this.currentDiff = this.lastValue - this.actualValue;
    } else {
      this.currentDiff = 0;
    }

    this.lastValue = this.actualValue;

    if (this.valueFixed) {
      if (showTooltip && this.tip) {
        this.showTooltip(this.i18n('amountFixed'));
      }
      this.valueFixed = false;
    }

    this.performChange();
    this.updateButtonsState();
  };
}


NumberInput.defaultProps = {
  allowEnter: false,
  min: null,
  max: null,
  defaultValue: 1,
  step: 1,
  wrapperClass: 'form-group__content',
  disabledStateClass: 'disabled',
  focusStateClass: 'focus',
  autofixTimeoutFloat: 1000,
  autofixTimeoutInteger: 500,
  autofixTimeoutEmpty: 2000,
  changeTimeout: 500,
  changeEvent: 'change',
  decreaseEvent: 'DHTML_NUMBER_DECREASE_PERFORMED',
  increaseEvent: 'DHTML_NUMBER_INCREASE_PERFORMED',
  showTooltip: true,
  actionButton: null,
}

export default NumberInput;



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/components/NumberInput.js